












import { Component, Vue } from 'vue-property-decorator';
import bianji from '../../../assets/image/bianji.png';
import { ajaxUserInfo } from '@/server';
// 声明组件*****************
@Component({
  components: {

  }
})
export default class UserDetail extends Vue {
  // 属性*****************
    private type: string = 'loading';
    private bianji: string = bianji;
    private detailsShowData: Array<any> = [
        [
            {
                name: '业主姓名',
                value: '',
                textAlign: 'right',
                enterShow: false,
            },
            {
                name: '联系电话',
                value: '',
                textAlign: 'right',
                enterShow: false,
            },
        ]
    ]

    activated ():void {
        document.title = '用户详情';
    }
    mounted ():void {
        ajaxUserInfo({
            open_id: this['$route']['query']['open_id'],
            role_status: 0,
        }).then((res: object) => {
            const { account, name } = res['data']['info_user'];
            this.detailsShowData[0][0].value = name;
            this.detailsShowData[0][1].value = account;
        }).catch((error: object) => {
            console.log(error)
        })
    }
    // 方法*****************



    // computed
    get routeQuery(): object {
        return {
            ...this.$route.query,
            type: 'edit'
        }
    }
}
